import {useEffect, useState} from 'react';
import {WalletNetwork} from '../../contexts/authentication-context/types';
import {useSmartContractContext} from '../../contexts/smart-contract/context';
import {isWeb3Contract} from '../../contexts/smart-contract/utils';

export const useMultiNftContract: ({
  multiCopy,
  tokenId,
  network,
}: {
  multiCopy: boolean;
  tokenId: number;
  network: WalletNetwork;
}) => string | undefined = ({multiCopy, tokenId, network}) => {
  const [totalSupply, setTotalSupply] = useState<string>();
  const {multiNFTContract} = useSmartContractContext();
  useEffect(() => {
    (async () => {
      const loadedMultiNFTContract = await multiNFTContract(network);

      if (!loadedMultiNFTContract) return;

      if (!isWeb3Contract(loadedMultiNFTContract)) return;

      if (!tokenId && tokenId !== 0) return;

      if (!multiCopy) {
        setTotalSupply(undefined);
        return;
      }

      // catch error when a user is changing networks and contract has not loaded
      const supply = await loadedMultiNFTContract
        .totalSupply(tokenId)
        .catch((e) => console.error(e));

      if (!supply) return;

      setTotalSupply(supply.toString());
    })();
    return () => setTotalSupply(undefined);
  }, [multiCopy, multiNFTContract, network, tokenId]);

  return totalSupply;
};
